import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatUnderline24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextFormatUnderline24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.75 4H5v3.35a.75.75 0 0 0 1.5 0V5.5H11v9H9.1a.75.75 0 0 0 0 1.5h5.433a.75.75 0 0 0 0-1.5H12.5v-9H17v1.85a.75.75 0 0 0 1.5 0V4zM5.5 18.5a.75.75 0 0 0 0 1.5H18a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextFormatUnderline24);
